import config from "../config/config";

const createSettings = async (settingsData, token) => {
    try {
        token = token.replace(/^"|"$/g, "").trim();

        const endpoint = `${config.baseSettingsUrl}/add`;

        const response = await fetch(endpoint, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify(settingsData),
        });

        if (!response.ok) {
            const errorMessage = await response.text();
            console.error("Response Error Message:", errorMessage);
            throw new Error(`HTTP error! status: ${response.status} - ${errorMessage}`);
        }

        return await response.json();
    } catch (error) {
        console.error("Error creating settings:", error);
        throw error;
    }
};

const updateSettings = async (id, updatedSettings, token) => {
    try {
        token = token.replace(/^"|"$/g, "").trim();

        const response = await fetch(`${config.baseSettingsUrl}/update/${id}`, {
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify(updatedSettings), // ✅ FIXED
        });

        if (!response.ok) {
            const errorMessage = await response.text();
            console.error("Response Error Message:", errorMessage);
            throw new Error(`HTTP error! status: ${response.status} - ${errorMessage}`);
        }

        return await response.json();
    } catch (error) {
        console.error("Error updating settings:", error);
        throw error;
    }
};

const deleteSettings = async (id) => {
    try {
        const token = JSON.parse(localStorage.getItem("token")); // Retrieve the token

        const response = await fetch(`${config.baseSettingsUrl}/delete/${id}`, {
            method: "DELETE",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
            },
        });

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        return await response.json();
    } catch (error) {
        console.error("Error deleting settings:", error);
        throw error;
    }
};

const getSettingsByCustomerId = async (token) => {
    try {
        token = token.replace(/^"|"$/g, "").trim();

        const endpoint = `${config.baseSettingsUrl}/get-by-customer`;

        const response = await fetch(endpoint, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
            },
        });

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        return await response.json();
    } catch (error) {
        console.error("Error fetching settings:", error);
        throw error;
    }
};

const uploadLogo = async (file, altText, token) => {
    try {
        token = token.replace(/^"|"$/g, "").trim();

        const formData = new FormData();
        formData.append("imageFile", file); // File field should match the backend
        if (altText) formData.append("alternativeText", altText); // Optional field

        const response = await fetch(`${config.baseSettingsUrl}/upload-logo`, {
            method: "POST",
            headers: {
                Authorization: `Bearer ${token}`,
            },
            body: formData,
        });

        if (!response.ok) {
            const errorMessage = await response.text();
            console.error("Response Error Message:", errorMessage);
            throw new Error(`HTTP error! status: ${response.status} - ${errorMessage}`);
        }

        return await response.json();
    } catch (error) {
        console.error("Error uploading logo:", error);
        throw error;
    }
};

const getLogoByCustomerId = async (token) => {
    try {
        token = token.replace(/^"|"$/g, "").trim(); // Clean token if needed

        const endpoint = `${config.baseSettingsUrl}/get-logo`; // Ensure the endpoint is correct

        const response = await fetch(endpoint, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
            },
        });

        if (!response.ok) {
            const errorMessage = await response.text();
            console.error("Response Error Message:", errorMessage);
            throw new Error(`HTTP error! status: ${response.status} - ${errorMessage}`);
        }

        const data = await response.json();
        return data;
    } catch (error) {
        console.error("Error fetching logo by customer ID:", error);
        throw error;
    }
};

const getShoppingDetailsByDateFromVideo = async (dateTimeString, token) => {
    try {
        const cleanedToken = token.replace(/^"|"$/g, "").trim();

        const url = `${config.baseStealingDetectionUrl}/shopping-history-by-date?dateTime=${encodeURIComponent(dateTimeString)}`;


        const response = await fetch(
            url,
            {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${cleanedToken}`,
                },
            }
        );

        if (!response.ok) {
            console.error("[getShoppingDetailsByDateFromVideo] Response not OK", response.status, response.statusText);
            throw new Error("Failed to fetch shopping details");
        }

        const result = await response.json();



        return result;
    } catch (error) {
        console.error("[getShoppingDetailsByDateFromVideo] Error fetching shopping details:", error);
        throw error;
    }
};



async function getUserNameById(userId) {
    try {
        const response = await fetch(`${config.baseAuthUrl}name-by-id?userId=${userId}`);
        if (!response.ok) throw new Error("User not found");
        const data = await response.json();
        return `${data.firstName} ${data.lastName}`;
    } catch (err) {
        console.error("Error fetching user name:", err);
        return "Okänd användare";
    }
}


export { createSettings, updateSettings, deleteSettings, getSettingsByCustomerId, uploadLogo, getLogoByCustomerId, getShoppingDetailsByDateFromVideo, getUserNameById };
